
import { MoonLoader as MoonSpinner } from 'react-spinners';
import './Spinner.scss';

type SpinnerProps = {
  isLoading: boolean;
};

function Spinner({ isLoading }: SpinnerProps) {
  return (
      <MoonSpinner className="moon-loader-orbit" color="#93186C" loading={isLoading} size={60} />
  );
}

export default Spinner;